module.exports = __webpack_public_path__ + "img/nj.9d593785.png";